import { useTranslation } from 'react-i18next';

const WE_MENTALITY_LOGO = "/assets/we-mentality-logo.png";

/**
 * Footer Component
 * Displays "A The WE Mentality Product" branding on all pages
 */
function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="w-full py-6 mt-auto print:hidden" data-testid="app-footer">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center justify-center gap-3">
          {/* Trust links — Privacy / Terms / Student Data Privacy */}
          <nav
            aria-label="Legal and trust links"
            className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs font-medium text-gray-500"
            data-testid="footer-legal-nav"
          >
            <a
              href="/privacy"
              className="hover:text-gray-800 transition-colors"
              data-testid="footer-privacy-link"
            >
              Privacy
            </a>
            <span aria-hidden="true" className="text-gray-300">·</span>
            <a
              href="/terms"
              className="hover:text-gray-800 transition-colors"
              data-testid="footer-terms-link"
            >
              Terms
            </a>
            <span aria-hidden="true" className="text-gray-300">·</span>
            <a
              href="/student-privacy"
              className="hover:text-gray-800 transition-colors"
              data-testid="footer-student-privacy-link"
            >
              Student Data Privacy
            </a>
            <span aria-hidden="true" className="text-gray-300">·</span>
            <a
              href="/security-and-student-data"
              className="hover:text-gray-800 transition-colors"
              data-testid="footer-security-link"
            >
              Security
            </a>
            <span aria-hidden="true" className="text-gray-300">·</span>
            <a
              href="/subprocessors"
              className="hover:text-gray-800 transition-colors"
              data-testid="footer-subprocessors-link"
            >
              Subprocessors
            </a>
            <span aria-hidden="true" className="text-gray-300">·</span>
            <a
              href="/delete-account"
              className="hover:text-gray-800 transition-colors"
              data-testid="footer-delete-account-link"
            >
              Delete Account
            </a>
          </nav>

          {/* Program Website */}
          <a 
            href="https://www.lemonadestandbusinessplan.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm font-semibold text-yellow-600 hover:text-yellow-700 transition-colors"
          >
            www.lemonadestandbusinessplan.com
          </a>

          {/* Divider */}
          <div className="w-16 h-px bg-gray-200"></div>

          {/* Logo + Text Lockup */}
          <div className="flex items-center gap-3">
            <img 
              src={WE_MENTALITY_LOGO}
              alt="The WE Mentality"
              className="h-8 w-auto object-contain"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <span className="text-gray-500 text-sm font-medium">
              A <span className="font-semibold text-gray-700">The WE Mentality</span> Product
            </span>
          </div>
          
          {/* TWM Website */}
          <a 
            href="https://www.thewementality.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-xs text-gray-400 hover:text-gray-600 transition-colors"
          >
            www.thewementality.com
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
